// The backend already sends a readable message, so we just show it.
export const formatNotificationMessage = (notification) => notification.message;
